export enum IdentityUrls {
  Login = "Identity/Login",
  Change = "Identity/ChangePassword",
  UserInfo = "Identity/UserInfo",
  UpdateUserInfo = "Identity/UpdateUserInfo",
  GetCaptcha = "Identity/GetCaptcha",
}
